import { Component } from 'react';
import { Button } from '@/components/ui/button';

/** Keeps a render-time crash from turning the whole app into a blank page. */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Render error:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6 bg-background"
        data-testid="app-error-boundary">
        <div className="max-w-md space-y-4 text-center">
          <h1 className="text-2xl font-semibold" style={{ fontFamily: '"Fraunces", Georgia, serif' }}>
            Something went wrong on this screen
          </h1>
          <p className="text-sm text-muted-foreground">
            Your work is saved. Reload the page, or go back to your projects and open the section again.
          </p>
          <pre className="text-[11px] text-left bg-muted/40 rounded p-2 overflow-x-auto max-h-32">
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <div className="flex gap-2 justify-center">
            <Button onClick={() => window.location.reload()} data-testid="error-reload-btn">
              Reload
            </Button>
            <Button variant="outline" onClick={() => window.location.assign('/thesis')}
              data-testid="error-projects-btn">
              My projects
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
